var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GovernanceUtils } from '@popup/steem/utils/governance.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import moment from 'moment';
import Config from 'src/config';
import FormatUtils from 'src/utils/format.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
export const WITNESS_DISABLED_KEY = 'STM1111111111111111111111111111111114T1Anm';
/* istanbul ignore next */
const voteWitness = (witness, voter, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    const witnessOperation = WitnessUtils.getWitnessVoteOperation(true, voter, witness.owner);
    return WitnessUtils.sendWitnessOperation(witnessOperation, voter, activeKey, options);
});
/* istanbul ignore next */
const unvoteWitness = (witness, voter, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    const witnessOperation = WitnessUtils.getWitnessVoteOperation(false, voter, witness.owner);
    return WitnessUtils.sendWitnessOperation(witnessOperation, voter, activeKey, options);
});
/* istanbul ignore next */
const updateWitnessVote = (voter, witness, approve, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    const witnessOperation = WitnessUtils.getWitnessVoteOperation(approve, voter, witness.owner);
    return WitnessUtils.sendWitnessOperation(witnessOperation, voter, activeKey, options);
});
/* istanbul ignore next */
const sendWitnessOperation = (witnessOperation, username, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    GovernanceUtils.removeFromIgnoreRenewal(username);
    return yield SteemTxUtils.sendOperation([witnessOperation], activeKey, false, options);
});
/* istanbul ignore next */
const getWitnessVoteOperation = (approve, voter, witnessName) => {
    return [
        'account_witness_vote',
        {
            account: voter,
            approve: approve,
            witness: witnessName,
        },
    ];
};
/* istanbul ignore next */
const getUpdateWitnessTransaction = (voter, witness, approve) => {
    return SteemTxUtils.createTransaction([
        WitnessUtils.getWitnessVoteOperation(approve, voter, witness.owner),
    ]);
};
const getWitnessAccountUpdateOperation = (witnessAccountName, witnessParamsForm) => {
    return [
        'witness_update',
        {
            owner: witnessAccountName,
            url: witnessParamsForm.url,
            block_signing_key: witnessParamsForm.signingKey,
            props: {
                account_creation_fee: `${Number(witnessParamsForm.accountCreationFee).toFixed(3)} STEEM`,
                maximum_block_size: Number(witnessParamsForm.maximumBlockSize),
                sbd_interest_rate: Number(witnessParamsForm.sbdInterestRate) * 100,
            },
            fee: '0.000 STEEM',
        },
    ];
};
const updateWitnessParameters = (witnessAccountName, witnessParamsForm, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    const witnessAccountUpdateOperation = getWitnessAccountUpdateOperation(witnessAccountName, witnessParamsForm);
    return yield SteemTxUtils.sendOperation([witnessAccountUpdateOperation], activeKey, true, options);
});
const getWitnessInfo = (username, globalProperties, currencyPrices) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let resultFromBlockchain;
    [resultFromBlockchain] = yield SteemTxUtils.getData('database_api.find_witnesses', {
        owners: [username],
    }, 'witnesses');
    const lastFeedUpdate = `${resultFromBlockchain.last_sbd_exchange_update}Z`;
    const witnessInfo = {
        rewards: {
            lastMonthValue: 0,
            lastMonthInSP: '',
            lastMonthInUSD: '',
            lastWeekValue: 0,
            lastWeekInSP: '',
            lastWeekInUSD: '',
            lastYearValue: 0,
            lastYearInSP: '',
            lastYearInUSD: '',
        },
        username: resultFromBlockchain.owner,
        votesCount: resultFromBlockchain.votes,
        voteValueInSP: FormatUtils.nFormatter(FormatUtils.toSP((Number(resultFromBlockchain.votes) / 1000000).toString(), globalProperties.globals), 3),
        blockMissed: resultFromBlockchain.total_missed,
        lastBlock: (_a = resultFromBlockchain.last_confirmed_block_num) === null || _a === void 0 ? void 0 : _a.toString(),
        lastBlockUrl: `https://steemdb.io/block/${resultFromBlockchain.last_confirmed_block_num}`,
        priceFeed: FormatUtils.fromNaiAndSymbol(resultFromBlockchain.sbd_exchange_rate.base),
        priceFeedUpdatedAt: moment(lastFeedUpdate),
        priceFeedUpdatedAtWarning: wasUpdatedAfterThreshold(moment(lastFeedUpdate)),
        signingKey: resultFromBlockchain.signing_key,
        url: resultFromBlockchain.url,
        version: resultFromBlockchain.running_version,
        isDisabled: resultFromBlockchain.signing_key === WITNESS_DISABLED_KEY,
        params: {
            accountCreationFee: FormatUtils.getAmountFromNai(resultFromBlockchain.props.account_creation_fee),
            accountCreationFeeFormatted: FormatUtils.fromNaiAndSymbol(resultFromBlockchain.props.account_creation_fee),
            maximumBlockSize: resultFromBlockchain.props.maximum_block_size,
            sbdInterestRate: resultFromBlockchain.props.sbd_interest_rate / 100,
        },
        // rewards: {
        //   lastMonthValue: resultFromAPI.lastMonthValue,
        //   lastMonthInHP: FormatUtils.toFormattedHP(
        //     resultFromAPI.lastMonthValue,
        //     globalProperties.globals!,
        //   ),
        //   lastMonthInUSD: FormatUtils.getUSDFromVests(
        //     resultFromAPI.lastMonthValue,
        //     globalProperties,
        //     currencyPrices,
        //   ),
        //   lastWeekValue: resultFromAPI.lastWeekValue,
        //   lastWeekInHP: FormatUtils.toFormattedHP(
        //     resultFromAPI.lastWeekValue,
        //     globalProperties.globals!,
        //   ),
        //   lastWeekInUSD: FormatUtils.getUSDFromVests(
        //     resultFromAPI.lastWeekValue,
        //     globalProperties,
        //     currencyPrices,
        //   ),
        //   lastYearValue: resultFromAPI.lastYearValue,
        //   lastYearInHP: FormatUtils.toFormattedHP(
        //     resultFromAPI.lastYearValue,
        //     globalProperties.globals!,
        //   ),
        //   lastYearInUSD: FormatUtils.getUSDFromVests(
        //     resultFromAPI.lastYearValue,
        //     globalProperties,
        //     currencyPrices,
        //   ),
        // },
    };
    return witnessInfo;
});
const wasUpdatedAfterThreshold = (updatedAt) => {
    const now = moment.utc();
    var duration = moment.duration(now.diff(updatedAt.utc()));
    var hours = duration.asHours();
    return hours > Config.witnesses.feedWarningLimitInHours;
};
const getLastSigningKeyForWitness = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.WITNESS_LAST_SIGNING_KEY);
    return result ? result[username] : null;
});
const saveLastSigningKeyForWitness = (username, key) => __awaiter(void 0, void 0, void 0, function* () {
    let result = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.WITNESS_LAST_SIGNING_KEY);
    if (!result) {
        result = {};
    }
    result[username] = key;
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.WITNESS_LAST_SIGNING_KEY, result);
});
const WitnessUtils = {
    unvoteWitness,
    voteWitness,
    getWitnessVoteOperation,
    sendWitnessOperation,
    updateWitnessVote,
    getUpdateWitnessTransaction,
    updateWitnessParameters,
    getWitnessInfo,
    wasUpdatedAfterThreshold,
    getLastSigningKeyForWitness,
    saveLastSigningKeyForWitness,
};
export default WitnessUtils;
